"use client";

import { c as _c } from "react/compiler-runtime";
import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { trackNavItemClicked } from "@/lib/analytics/segment";
import { type NavItemEntry, navItemDestination } from "@/lib/contentful/navItem";
import { colorClass } from "@/lib/contentful/ui";
import { cn } from "@/lib/utils";
import { CmsLink } from "./CmsLink";
interface Props {
  items: NavItemEntry[];
}
export function NavDropdown(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="min-w-45 p-1">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item) {
  const {
    title,
    color,
    isNewTab
  } = item.fields;
  return <li key={item.sys.id}><NavigationMenuLink asChild={true}><CmsLink destination={navItemDestination(item)} isNewTab={isNewTab} className={cn("block rounded-sm px-3 py-1.5 text-sm font-bold no-underline! hover:bg-accent hover:opacity-100!", colorClass(color))} onNavigate={href => trackNavItemClicked({
        label: title,
        destinationUrl: href,
        level: 2
      })}>{title}</CmsLink></NavigationMenuLink></li>;
}